export const SEARCH_RESULTS_ROOT = 'search-results-root';
export const SEARCH_RESULTS_CONTENT_WRAPPER = 'search-results-content-wrapper';
export const SEARCH_RESULTS_LOADER = 'search-results-loader';
export const SEARCH_RESULTS_HEADER = 'search-results-header';
export const SEARCH_RESULTS_QUERY = 'search-results-query';
export const SEARCH_RESULTS_LEFT_SIDE = 'search-results-left-side';
export const SEARCH_RESULTS_BACKDROP = 'search-results-backdrop';
export const POPULAR_PRODUCTS_ROOT = 'popular-products-root';
export const POPULAR_SEARCH_QUERIES_ROOT = 'popular-search-queries-root';
export const POPULAR_SEARCH_QUERIES_HEADING = 'popular-search-queries-heading';
export const POPULAR_SEARCH_QUERIES_RESULTS = 'popular-search-queries-results';
export const POPULAR_SEARCH_QUERIES_ITEM = 'popular-search-queries-item';
export const POPULAR_SEARCH_QUERIES_LINK = 'popular-search-queries-link';
